var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 15,
    viewBox: "0 0 19 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "elements"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.33398 7.4987C1.33398 4.55079 1.33398 3.07684 2.21132 2.09278C2.35164 1.93539 2.5063 1.78983 2.67353 1.65776C3.7191 0.832031 5.28517 0.832031 8.41732 0.832031H10.9173C14.0495 0.832031 15.6155 0.832031 16.6611 1.65776C16.8283 1.78983 16.983 1.93539 17.1233 2.09278C18.0007 3.07684 18.0007 4.55079 18.0007 7.4987C18.0007 10.4466 18.0007 11.9206 17.1233 12.9046C16.983 13.062 16.8283 13.2076 16.6611 13.3396C15.6155 14.1654 14.0495 14.1654 10.9173 14.1654H8.41732C5.28517 14.1654 3.7191 14.1654 2.67353 13.3396C2.5063 13.2076 2.35164 13.062 2.21132 12.9046C1.33398 11.9206 1.33398 10.4466 1.33398 7.4987Z",
    stroke: "#3D3D3D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.00098 10.832H9.25098",
    stroke: "#3D3D3D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.751 10.832L14.6676 10.832",
    stroke: "#3D3D3D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 4043",
    d: "M1.33398 5H18.0007",
    stroke: "#3D3D3D",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayment);
export default __webpack_public_path__ + "static/media/payment.1243a903c8dfe06b35b4db22bf9f22e8.svg";
export { ForwardRef as ReactComponent };